import { Button } from 'components/atoms';
import ThreadCard from 'components/molecules/card/thread/ThreadCard';
import ListWrapper from 'components/molecules/list-wrapper/ListWrapper';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarPage } from 'components/templates';
import { useScroll } from 'components/templates/application/ApplicationTemplate';
import { useTranslation } from 'react-i18next';
import { PiPlus } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { useGetThreads } from 'services/chat';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const SettingsSupportThread = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const threads = useGetThreads();

  const scroll = useScroll({ fetchNextPage: threads.fetchNextPage });

  return (
    <TopbarPage
      topbarAbsolute
      topbar={
        <TopBar
          title={t('support.title')}
          customBackItem={<div />}
          topbarContent={
            <Button variant={BUTTON_VARIANT.submit} onlyIcon onClick={() => navigate('create')}>
              <Button.Icon icon={<PiPlus />} />
              <Button.Description description={t('support.add')} />
            </Button>
          }
        />
      }
    >
      <ListWrapper
        items={threads.data?.pages.flat()}
        isLoading={threads.isLoading}
        isFetchingNextPage={threads.isFetchingNextPage}
        item={(thread) => (
          <ThreadCard
            key={thread.messageThreadId}
            thread={thread}
            onClick={(thread) => navigate(`/support/${thread.messageThreadId}`)}
          />
        )}
      />
    </TopbarPage>
  );
};

export default SettingsSupportThread;
